import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { User } from "./interface";

const initialState: User = {
  userState: false,
  currentUser: [],
  
};

/***********************************
 * error cannot be named without a reference to '@reduxjs/toolkit/node_modules/immer
 * make sure that is being exported once only 
 ***********************************/

const userSlice = createSlice({
  name: "user",
  initialState,

  reducers: {
    // this operation will populate any type of arary 
    onCurrentUserInfo: (state, action: PayloadAction<any[]>) => {
      state.currentUser = action.payload;
    },
    onUserState: (state, action: PayloadAction<boolean>) => {
      state.userState = action.payload;
    },
    // // use in the invoice component - retrieve the data for automatic count
    // addInvoiceId: (state, action: PayloadAction<any[]>) => {
    //   state.invoiceId = action.payload;
    // }
  },
});
export const {onCurrentUserInfo, onUserState} = userSlice.actions;
export default userSlice.reducer;